import VehiclePhysicalCondition from '../../../../../pages/vip/features/vehicle-physical-condition/index';

export default VehiclePhysicalCondition;
